import moment from 'moment';
import { getShipmentsFailure } from '../../../store/shipments/shipments.actions';
import { id as fulfillmentTypeId } from '../../../filters/options/fulfillment-type';
import { fulfillments } from '../../../filters/options/fulfillment-type/options';
import { id as shipDateId } from '../../../filters/options/ship-date';
import { id as submissionDate } from '../../../filters/options/submission-date';
import { FulfillmentsAdvancedSearch } from '../../../components/shipping-grid/views/fulfillments-advanced-search';

import { noop } from 'ui-components/default-props/noop';

export default {
  filterBuilder: undefined,
  apiCall: undefined, // the grid itself makes the call when the filters change
  baseUrl: 'fulfillments',
  successActions: [],
  failureAction: getShipmentsFailure,
  convertResponse: noop,
  view: FulfillmentsAdvancedSearch,
  getOrderBy: () => ({}),
  initialFilters: [
    {
      id: fulfillmentTypeId,
      value: fulfillments.apiKey,
    },
    {
      id: shipDateId,
      value: {
        from: moment().add(-90, 'days'),
      },
    },
    {
      id: submissionDate,
      value: {
        from: moment().add(-90, 'days'),
      },
    },
  ],
};
